<template>
  <div class="order-bid order__body">
    <div class="order__left pt-16 sm:pt-40">
      <div class="orderDetail mb-24">
        <orderDetailCardBid v-for="item in order.rooms" :key="item.id" :rooms="item" :order="order"></orderDetailCardBid>
        <orderAddonDetailCardBid :order="order" />
      </div>
      <orderFormBid ref="orderFormBid" />
      <orderPaymentBid ref="orderPaymentBid" :order="order" />
      <div class="p-16 sm:p-24 border-1 border-blue-light bg-blue-lightest mt-16 md:mt-40" style="border-radius: 20px;">
        <div class="flex justify-between flex-wrap">
          <div class="owl-checkbox-wrap">
            <label for="travelPolicyCheck" style="align-items: flex-start;">
              <input type="checkbox" id="travelPolicyCheck" v-model="isPolicyChecked">
              <div class="owl-checkbox flex-no-shrink"></div>
              <span class="cursor-default leading-normal" v-html="$t('bid.form.rule1', { link: paynowPdfLink })" @click="clickBidRule" />
            </label>
            <label for="policyCheck">
              <input type="checkbox" id="policyCheck" v-model="isBidPolicyChecked">
              <div class="owl-checkbox flex-no-shrink"></div>
              <span class="cursor-default leading-normal">
                {{ $t('bid.form.rule2') }}
              </span>
            </label>
          </div>
        </div>
      </div>
      <div class="flex flex-row items-center justify-center mt-24 md:mt-40">
        <div v-if="!canBidTimes" class="flex flex-col">
          <div class="flex items-center" style="line-height: 24px">
            <div class="text-white rounded-l-full font-medium text-sm py-8 px-16 cursor-pointer" @click="addLine" style="background-color: #00C300;"
              :style="taskContain('ADD_LINE') && 'opacity: 30%; cursor: not-allowed;'">
              {{ $t('bid.addChance.line') }}
            </div>
            <div class="bg-black text-white rounded-r-full font-medium text-sm py-8 px-16 cursor-pointer" @click="appDownload"
              :style="taskContain('DOWNLOAD_APP') && 'opacity: 30%; cursor: not-allowed;'">
              {{ $t('bid.addChance.app') }}
            </div>
          </div>
          <div class="w-full text-center text-sm font-medium mt-4 text-grey-darker">
            {{ $t('bid.addChance.desp') }}
          </div>
        </div>
        <div :class="[!canBidTimes && 'ml-8']">
          <div class="w-full text-center">
            <div class="btn btn-solid btn-blue-light px-16 py-8 text-center no-underline cursor-pointer flex-no-shrink rounded-full" @click="submitForm" :disabled="!canSubmitForm">
              {{ $t('bid.form.bidNow') }}
            </div>
          </div>
          <div class="w-full text-center text-sm font-medium mt-4 text-grey-darker">
            {{ $t('bid.form.remaining') }}
            <span class="text-red font-bold">{{ canBidTimes }}</span>
            {{ $t('bid.form.times') }}
          </div>
        </div>
      </div>
    </div>
    <div class="order__right mt-32 lg:mt-0" :class="$route.name === 'OrderConfirmation' ? 'hidden' : ''">
      <orderAsideBidNew ref="orderAsideBid" :abtest="bidABTest" />
    </div>
    <modal name="bidFailure" classes="bid-result-modal" :width="345" :height="'auto'" :adaptive="true" :click-to-close="false">
      <img src="@/assets/images/bargain/bid-failure.png" alt="">
      <div class="bg-white py-24 text-center" style="border-bottom-left-radius: 20px; border-bottom-right-radius: 20px; margin-top: -4px">
        <div class="text-grey-darkest font-bold text-2xl" style="line-height: 36px">{{ $t('bid.response.fail') }}</div>
        <div class="text-grey-darkest text-sm" style="line-height: 24px">{{ bidFailMsg }}</div>
        <div class="btn btn-solid btn-blue-light mt-16 px-16 py-8 text-center no-underline cursor-pointer flex-no-shrink rounded-full border-1 border-blue-light text-base" @click="closeBidFailure">
          {{ userHotelCanBid ? $t('bid.response.bidAgain') : $t('bid.response.backToHotel') }}
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

import orderFormBid from '@/views/Order/components/OrderFormBid'
import orderAsideBidNew from '@/views/Order/components/OrderAsideBidNew'
import orderDetailCardBid from '@/components/orderDetailCardBid'
import orderAddonDetailCardBid from '@/components/orderAddonDetailCardBid'
import orderPaymentBid from '@/views/Order/components/OrderPaymentBid'
import { createHelpers } from 'vuex-map-fields'
import animateScrollTo from 'animated-scroll-to'
import ls from '@/utils/ls'

const { mapFields } = createHelpers({
  getterType: 'order/getField',
  mutationType: 'order/updateField'
})

const PAYNOW_PDF_LINK = {
  zh_TW: 'https://paynow-public.s3.ap-northeast-1.amazonaws.com/docs/%E6%9C%83%E5%93%A1%E6%A2%9D%E6%AC%BE%E8%88%87%E7%9B%B8%E9%97%9C%E6%9C%8D%E5%8B%99202300612.2306.pdf',
  others: 'https://paynow-public.s3.ap-northeast-1.amazonaws.com/docs/%E6%9C%83%E5%93%A1%E6%A2%9D%E6%AC%BE%E8%88%87%E7%9B%B8%E9%97%9C%E6%9C%8D%E5%8B%99202300612.2306.pdf'
}

export default {
  name: 'OrderBid',
  components: {
    orderFormBid,
    orderAsideBidNew,
    orderDetailCardBid,
    orderAddonDetailCardBid,
    orderPaymentBid
  },
  data () {
    return {
      isPolicyChecked: false,
      isBidPolicyChecked: false,
      isOrderSubmitting: false,
      bidFailStatus: '',
      bidFailMsg: '',
      appUrl: {
        ios: 'https://apps.apple.com/tw/app/%E5%A5%A7%E4%B8%81%E4%B8%81%E6%8F%AA%E4%BD%A0%E9%AB%94%E9%A9%97/id1552125085',
        android: 'https://play.google.com/store/apps/details?id=com.owlting.app.owljourney'
      },
      bidABTest: ''
    }
  },
  computed: {
    ...mapGetters({
      profile: 'user/profile',
      order: 'order/order',
      metadata: 'metadata/metadata',
      bidder: 'order/bidder',
      'user/selectedLang': 'user/selectedLang',
      windowWidth: 'windowWidth'
    }),
    ...mapFields({
      payMethod: 'payment.payMethod',
      creditCardType: 'payment.creditCard.type',
      creditCardName: 'payment.creditCard.name',
      creditCardNumber: 'payment.creditCard.number',
      creditCardExpiryDate: 'payment.creditCard.expiryDate',
      creditCardCvc: 'payment.creditCard.cvc',
      note: 'form.note',
      customerFirstName: 'form.customer.firstName',
      customerLastName: 'form.customer.lastName',
      customerPhoneCode: 'form.customer.phoneCode',
      customerPhoneNumber: 'form.customer.phoneNumber',
      customerGender: 'form.customer.gender',
      customerEmail: 'form.customer.email',
      companyName: 'form.receiptInfo.companyName',
      companyNumber: 'form.receiptInfo.companyNumber'
    }),
    canSubmitForm () {
      return this.isPolicyChecked && this.isBidPolicyChecked && !this.isOrderSubmitting && (this.canBidTimes > 0)
    },
    canBidTimes () {
      return this.bidder?.chance
    },
    appDownloadUrl () {
      return (!window.MSStream && /iPad|iPhone|iPod/.test(navigator.userAgent))
        ? this.appUrl.ios
        : this.appUrl.android
    },
    userHotelCanBid () {
      return this.bidder?.canBid && (this.bidder?.chance !== 0 || this.bidder?.completedTasks.length !== 2)
    },
    paynowPdfLink: function () {
      return this['user/selectedLang'] === 'zh_TW' ? PAYNOW_PDF_LINK['zh_TW'] : PAYNOW_PDF_LINK['others']
    }
  },
  methods: {
    ...mapActions([
      'order/onSubmitOrderBid',
      'order/postTask',
      'user/goLogin',
      'order/getBidding'
    ]),
    submitForm: async function () {
      if (!this.canSubmitForm) {
        return false
      }
      Promise.all([this.$refs['orderFormBid'].onFormValidate(), this.$refs['orderPaymentBid'].onCardValidate(), this.$refs['orderAsideBid'].onBidNumberValidate()])
        .then(res => {
          window.dataLayer.push({
            event: this.bidABTest === 'A' ? 'order_bid_A' : 'order_bid_B'
          })
          this.startBidding()
        })
    },
    startBidding: function () {
      this.isOrderSubmitting = true
      this['order/onSubmitOrderBid']()
        .then(res => {
          // console.log('res', res)
          if (res.status === 200) {
            location.replace(res.data.redirectUrl)
          } else {
            this.bidFailMsg = this.metadata.i18n[res.msg]
            this.$modal.show('bidFailure', {
              root: true
            })
          }
        })
        .finally(() => {
          this.isOrderSubmitting = false
        })
    },
    closeBidFailure () {
      this.$modal.hide('bidFailure')
      if (!this.userHotelCanBid) {
        const route = this.$router.resolve({
          name: 'HotelDetail',
          params: { hotelId: this.order.hotel.hotelUUID },
          query: {
            externalId: this.order.hotel.hotelUUID,
            searchId: this.order.hotel.hotelUUID,
            searchType: 'hotel',
            source: this.order.source,
            start: this.order.startAt,
            end: this.order.endAt
          }
        })
        window.location = route.href
      } else {
        if (this.windowWidth < 992) {
          animateScrollTo(document.getElementsByClassName('orderAsideBid'), {
            offset: -200,
            speed: 800
          })
        }
      }
    },
    taskContain (task) {
      return this.bidder?.completedTasks?.includes(task)
    },
    addLine () {
      if (this.taskContain('ADD_LINE')) {
        return false
      }
      window.dataLayer.push({
        event: 'order_bid_line'
      })

      window.open('https://lin.ee/a6wBuLI', '_blank')
      this['order/postTask']({
        hotelUUID: this.order.hotel.hotelUUID,
        hotelSource: this.order.source,
        taskName: 'ADD_LINE'
      })
    },
    appDownload () {
      if (this.taskContain('DOWNLOAD_APP')) {
        return false
      }
      window.dataLayer.push({
        event: 'order_bid_app'
      })

      window.open(this.appDownloadUrl, '_blank')
      this['order/postTask']({
        hotelUUID: this.order.hotel.hotelUUID,
        hotelSource: this.order.source,
        taskName: 'DOWNLOAD_APP'
      })
    },
    clickBidRule () {
      window.dataLayer.push({
        event: 'order_activity-rules'
      })
    },
    bidTextABTest () {
      if (!ls.get('owljourney_bid_abtest')) {
        const randomNumber = Math.random()
        if (randomNumber < 0.5) {
          this.bidABTest = 'A'
        } else {
          this.bidABTest = 'B'
        }
        ls.set('owljourney_bid_abtest', this.bidABTest)
      } else {
        this.bidABTest = ls.get('owljourney_bid_abtest')
      }
    }
  },
  created () {
    this.bidTextABTest()
  },
  mounted () {
    this.$nextTick(() => {
      if (!this.bidder) {
        this['order/getBidding']({ hotelUUID: this.order?.hotel.hotelUUID, hotelSource: this.order?.hotel.source || this.order?.hotel.hotelSource })
          .then(res => {
            if (!this.userHotelCanBid) {
              const route = this.$router.resolve({
                name: 'HotelDetail',
                params: { hotelId: this.order?.hotel.hotelUUID },
                query: {
                  externalId: this.order?.hotel.hotelUUID,
                  searchId: this.order?.hotel.hotelUUID,
                  searchType: 'hotel',
                  source: this.order?.source,
                  start: this.order?.startAt,
                  end: this.order?.endAt
                }
              })
              window.location = route.href
            }
          })
      } else {
        if (!this.userHotelCanBid) {
          const route = this.$router.resolve({
            name: 'HotelDetail',
            params: { hotelId: this.order?.hotel.hotelUUID },
            query: {
              externalId: this.order?.hotel.hotelUUID,
              searchId: this.order?.hotel.hotelUUID,
              searchType: 'hotel',
              source: this.order?.source,
              start: this.order?.startAt,
              end: this.order?.endAt
            }
          })
          window.location = route.href
        }
      }
    })
  }
}
</script>
<style lang="sass" scoped>
.order-bid
  .order__right
    @apply pl-0
    @screen sm
      @apply pl-0
</style>
